export enum FuelSource {
  Electricity = "electricity",
  NaturalGas = "naturalGas",
  Propane = "propane",
  FuelOil = "fuelOil",
  Diesel = "diesel",
  Gasoline = "gasoline",
  Carbon = "carbon",
  Refrigerants = "refrigerants",
}

// carbon and refrigerant efficiency is not part of the current app
export enum FuelSourceThatSupportsEfficiency {
  Electricity = "electricity",
  NaturalGas = "naturalGas",
  Propane = "propane",
  FuelOil = "fuelOil",
  Diesel = "diesel",
  Gasoline = "gasoline",
}

export enum FuelSourceThatSupportsElectrification {
  NaturalGas = "naturalGas",
  Propane = "propane",
  FuelOil = "fuelOil",
  Diesel = "diesel",
  Gasoline = "gasoline",
}
